export default {
  header: 'Kies menu',
  open_now: 'Nu open',
};
